import * as React from 'react'

import { TabsContext } from '../tabsContext'

import * as styles from './tab.module.css'

interface IProps {
  value: any
  children: React.ReactNode
}

const Tab = ({ value, children }: IProps) => (
  <TabsContext.Consumer>
    {({ tabsValue, onChange }) => {
      const isActive = tabsValue === value
      const activeStyle = isActive ? styles.active : ''
      const Element = isActive ? 'span' : 'button'
      return (
        <Element
          onClick={() => onChange(value)}
          className={`${styles.root} ${activeStyle}`}
          role="tab"
          aria-selected={isActive}
        >
          {children}
        </Element>
      )
    }}
  </TabsContext.Consumer>
)

export default Tab
